module.exports = __webpack_public_path__ + "img/icon_shujvfenxi.bc383886.png";